import React from 'react';
import pdfFileIcon from '../assets/pdf-file-icon.png';

interface PdfBadgeIconProps {
  isDarkMode: boolean;
  className?: string;
}

const PdfBadgeIcon: React.FC<PdfBadgeIconProps> = ({ isDarkMode: _isDarkMode, className = '' }) => {
  return (
    <img
      src={pdfFileIcon}
      alt=""
      aria-hidden="true"
      className={`h-8 w-8 shrink-0 object-contain ${className}`.trim()}
      draggable={false}
    />
  );
};

export default PdfBadgeIcon;
